import { pressHandlers } from "./press-handlers";
import "./galaxy-map-button.css";

export function GalaxyMapButton({ onOpen }: { onOpen: () => void }) {
  return (
    <button
      type="button"
      className="galaxy-map-button"
      aria-label="Карта галактики"
      aria-haspopup="dialog"
      {...pressHandlers(onOpen)}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m6 6 11 3-5 10-6-13Zm0 0L3 16l9 3M17 9l4 8-9 2" />
        <circle cx="6" cy="6" r="2" />
        <circle cx="17" cy="9" r="2" />
        <circle cx="12" cy="19" r="2" />
      </svg>
    </button>
  );
}
